import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PoTableFilterSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/po-ledger/_list/')({
  validateSearch: zodValidator(PoTableFilterSchema)
});